/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, type ReactNode } from 'react';

const SettingsWorkspaceLayoutContext = createContext(false);

export const SETTINGS_NAV_COLLAPSED_KEY = 'notifi:settings-nav-collapsed';
export const SETTINGS_NAV_TOGGLE_EVENT = 'notifi:toggle-settings-navigation';

export function SettingsWorkspaceLayoutProvider({ children }: { children: ReactNode }) {
  return (
    <SettingsWorkspaceLayoutContext.Provider value>
      {children}
    </SettingsWorkspaceLayoutContext.Provider>
  );
}

export function useSettingsWorkspaceLayout() {
  return useContext(SettingsWorkspaceLayoutContext);
}
